import L from 'leaflet';

export default {
    init: ( element ) => {

        $(element).each(( i ) => {
            const $map = $(element).eq(i);
            if ( $map.length && $map.data('latitude') && $map.data('longitude') && $map.data('leaflet-id') && $map.data('leaflet-token') ) {

                if ($map.data('height') && $($map.data('height')).length && $(window).width() > 800) {
                    $map.height($($map.data('height')).height());
                }

                const map = new L.Map($map.get(0)).setView([$map.data('latitude'), $map.data('longitude')], 18);

                /*const tiles = */new L.TileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/256/{z}/{x}/{y}?access_token={accessToken}', {
                    attribution: 'Données de carte &copy; <a href="http://openstreetmap.org">OpenStreetMap</a>, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Styles de carte © <a href="http://mapbox.com">Mapbox</a>',
                    maxZoom: 20,
                    id: ( $map.data('leaflet-id') ? $map.data('leaflet-id') : 'rkcreation/ciwdjzek2001t2pmt5ksagti1' ),
                    accessToken: ( $map.data('leaflet-token') ? $map.data('leaflet-token') : 'pk.eyJ1IjoicmtjcmVhdGlvbiIsImEiOiJjaXdkaXVnbXkwMDlsMnlrNGNqMWNtaTJrIn0.CvTMiywr8JeGDihxM1MRJw' ),
                }).addTo(map);

                let customIcon = L.icon({
                    iconUrl: $map.data('marker-url'),
                    iconSize:     [parseInt($map.data('marker-width')), parseInt($map.data('marker-height'))], // size of the icon
                    iconAnchor:   [(Math.floor($map.data('marker-width')) / 2), parseInt($map.data('marker-height'))], // point of the icon which will correspond to marker's location
                    shadowAnchor: [((Math.floor($map.data('marker-width')) / 2) + 2), parseInt($map.data('marker-height'))],  // the same for the shadow
                    popupAnchor:  [-3, (Math.floor($map.data('marker-width')) / 2 * -1)], // point from which the popup should open relative to the iconAnchor
                });

                /*const marker = */L.marker([$map.data('latitude'), $map.data('longitude')], {icon: customIcon}).addTo(map);

            }
        });

    },
};



// WEBPACK FOOTER //
// ./scripts/util/MapLeaflet.js